// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FaqTopic_wrapper","question":"FaqTopic_question","answer":"FaqTopic_answer","back-link":"FaqTopic_back-link","backLink":"FaqTopic_back-link"};